const nonUsSupportedRegions = {
    EU: '.eu',
    eu: '.eu',
    AU: '.com.au',
    au: '.com.au',
    JP: '.jp',
    jp: '.jp',
    CA: '.ca',
    ca: '.ca',
};

export default nonUsSupportedRegions;

const getNonUsSupportedRegionsSet = (): Set<string> => {
    const regions = new Set<string>();
    for (let code in nonUsSupportedRegions) {
        regions.add(code.toUpperCase());
    }

    return regions;
};
export const nonUsSupportedRegionsSet = getNonUsSupportedRegionsSet();

const getNonUsSupportedTopLevelDomains = (): Array<string> => {
    const tldSet = new Set<string>();

    for (let region in nonUsSupportedRegions) {
        const tld = nonUsSupportedRegions[region];
        tldSet.add(tld);
    }

    return Array.from(tldSet);
};
export const nonUsSupportedTopLevelDomains = getNonUsSupportedTopLevelDomains();

export const nonUsSupportedRegionsArr = Array.from(getNonUsSupportedRegionsSet());
